import { render } from "./ModalNuovaRevisione.vue?vue&type=template&id=be1c0850"
import script from "./ModalNuovaRevisione.vue?vue&type=script&lang=js"
export * from "./ModalNuovaRevisione.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__